import { forwardRef, type Ref, type SVGProps } from "react";
const IconTrophyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M22.54 17.9c8.7-2.11 7.38-11 7.37-11.06a1 1 0 0 0-1-.84H24V5a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v1H3.08a1 1 0 0 0-1 .84c0 .09-1.33 9 7.37 11.06 1.33 2.39 3.4 4.47 5.57 5a1 1 0 0 0-.02.1v5h-5a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2h-5v-5a.6.6 0 0 0 0-.13c2.14-.5 4.22-2.59 5.54-4.97M24 13V8h4a7.49 7.49 0 0 1-4.41 7.45A8.4 8.4 0 0 0 24 13M4 8h4v5a8.6 8.6 0 0 0 .41 2.45A7.47 7.47 0 0 1 4 8m15.33 3.13L18 12.53l.25 1.94c.06.46-.22.66-.63.45L16 14.07l-1.66.85c-.41.21-.69 0-.63-.45l.29-1.94-1.29-1.4c-.31-.34-.19-.68.26-.76l1.77-.37.88-1.73c.21-.4.55-.4.76 0l.88 1.73 1.81.34c.45.11.57.45.26.79" />
  </svg>
);
const ForwardRef = forwardRef(IconTrophyFilledSVG);
ForwardRef.displayName = "IconTrophyFilled";
export { ForwardRef as IconTrophyFilled };
